// Section colours are defined per-theme in src/sass/app.scss (:root / .v-theme--light).
// These CSS var references keep JS consumers (loading bar, search dots) theme-aware.
export const SECTION_COLORS = {
  // `icon` is the shade for small glyphs (dots, icons) — matches `bg` except
  // for the campaign yellow, which deepens on light surfaces for legibility
  campaign: { bg: 'var(--c-campaign)', text: 'var(--c-campaign-text)', shadow: 'var(--c-campaign-shadow)', icon: 'var(--c-campaign-icon)' },
  creative: { bg: 'var(--c-creative)', text: 'var(--c-creative-text)', shadow: 'var(--c-creative-shadow)', icon: 'var(--c-creative)' },
  profile:  { bg: 'var(--c-profile)', text: 'var(--c-profile-text)', shadow: 'var(--c-profile-shadow)', icon: 'var(--c-profile)' },
}

export function getSectionFromRoute(routeName) {
  if (!routeName) return null
  const prefix = routeName.split('.')[0]
  const normalized = prefix.replace(/s$/, '')
  if (normalized === 'campaign') return 'campaign'
  if (normalized === 'creative') return 'creative'
  if (normalized === 'profile') return 'profile'
  return null
}

export function getSectionColor(routeName) {
  const section = getSectionFromRoute(routeName)
  return section ? SECTION_COLORS[section] : null
}
